import * as $ from 'jquery';
import * as kendo from 'kendo';
import * as publisher from 'publisher';
import * as page from 'CMS/core/page';
import * as app from 'CMS/core/application';
import * as conf from 'CMS/conf';
import * as params from 'CMS/core/params';
import { IWidget } from 'CMS/core/Widget';


export default class Container {
    private $titleLabel: JQuery;
    private $container: JQuery;
    private $wrapper: JQuery;
    private $btnArea: JQuery;
    private $addToDashboardDiv: JQuery = null
    private $dashboardSelect: any = null;
    private $moduleContent: JQuery;

    private widgetTopicname: string;
    private rememberedHeight: number;
    private dashboards: any = null;

    private _widget: IWidget;
    private _instance: any;
    private _global: any;

    private _sortable: any;
    private _state: any;
    private _fp: any = null;



    private _fixedActions = {
        deleteWidget: {
            name: "delete", text: "delete", className: 'glyphicon glyphicon-trash', onclick: (e: any) => { this.delete(e); }, button: <any>null
        },
        maximize: {
            name: "maximize", text: "maximize", className: 'vl-icon vl-maximize', onclick: (e: any) => { this.maximize(e); }, button: <any>null
        },
        minimize: {
            name: "minimize", text: "minimize", className: 'glyphicon glyphicon-minus', onclick: (e: any) => { this.minimize(e); }, button: <any>null
        },
        print: {
            name: "print", text: "print", className: 'vl-icon vl-print', onclick: (e: any) => { this.print(e); }, button: <any>null
        },
        refresh: {
            name: "refresh", text: "refresh", className: 'k-icon k-i-refresh', button: <any>null
        },
        help: {
            name: "help", text: "help", className: 'glyphicon glyphicon-question-sign', onclick: (e: any) => { this.help(e); }, button: <any>null
        },
        addDashboard: {
            name: "addDashboard", text: "addDashboard", className: 'glyphicon glyphicon-th', onclick: (e: any) => { this.addToDashboard(e); }, button: <any>null
        }
    };

    public get wrapper(): JQuery {
        return this.$wrapper;
    }
    public get container(): JQuery {
        return this.$container;
    }
    public get widget(): any {
        return this._widget;
    }
    public get configuredHeight(): number {
        return parseInt(this.getContainer()[0].style.height) || 0;
    }

    public sendAction(actionName: string) {
        publisher.publish(this.widgetTopicname, { action: actionName, state: this.getState() });
    }

    public setTitle(title: string) {
        // Using text() instead of html() to prevent Cross-site scripting
        this.$titleLabel.text(title);
    }

    public initialize(opt: any): Promise<Container> {
        return new Promise((resolve, reject) => {
            try {
                this._instance = opt.instance;
                this._global = opt.global;
                this.dashboards = this._global.db;

                this.$container = $('#' + this._instance.iid);
                this.$wrapper = this.$container.closest('.widget');
                this.$titleLabel = this.$wrapper.find('.lblTitle');


                //Get the configuration for the application
                var parameters: { state?: any, [key: string]: any } = {};
                if (this._instance.app != null) {
                    var _appInfo = app.getAppInfo(this._instance.app);
                    this._instance.ru = _appInfo.location;
                    this._instance.appConf = _appInfo.appConf;

                    //Configuration must be joined with application level configuration                

                    $.extend(parameters, conf.getAppParams(this._instance.app));
                    $.extend(parameters, conf.getAppParamsForUser(this._instance.app));
                    $.extend(parameters, conf.getDefParams(this._instance.did));
                    $.extend(parameters, conf.getDefParamsForUser(this._instance.did));
                    $.extend(parameters, conf.getPageParams());
                    $.extend(parameters, conf.getPageParamsForUser());
                    $.extend(parameters, conf.getModInstParams(this._instance.iid));
                    $.extend(parameters, conf.getModInstParamsForUser(this._instance.iid));

                    $.each(parameters, (k: any, v: any) => {
                        if ($.type(v) === "string") {
                            parameters[k] = params.evaluateParams(v);
                        }
                    });
                }

                this._state = parameters.state;
                if (this._state == null) { this._state = "normal"; }

                this.widgetTopicname = "AWF.widget." + this._instance.iid;

                //initialize container

                this.$wrapper.data('container', this);
                this.$btnArea = this.$wrapper.find('.a-header .a-icons');
                this.$moduleContent = this.$wrapper.find('.moduleContent');
                this._sortable = this.$container.closest(".dragDrop");

                var $advancedOptionsLink = this.$wrapper.find('[data-action="advanced-options"] > a');
                $advancedOptionsLink.on('click', (e: any) => {
                    e.preventDefault();
                    this.showAdvancedOptions(this._instance.iid.substring(1));
                });


                this.initButtons();

                if (this._instance.w != null) {
                    if (this._instance.m) { /* Check if we should require a main file first */
                        import(this._instance.m).then(mainFile => {
                            this.requireAndInitializeWidget(this._instance, parameters).then((widget) => { resolve(this); }).catch((e) => { reject(e); });
                        });
                    } else {
                        this.requireAndInitializeWidget(this._instance, parameters).then((widget) => { resolve(this); }).catch((e) => { reject(e); });;
                    }
                } else {
                    reject();
                }
                this.setGUIState();
            } catch (ex) {
                reject(ex);
            }
        });
    };
    public destroy() { };

    private requireAndInitializeWidget(widgetInstance: any, params: any): Promise<IWidget> {
        return new Promise<IWidget>((resolve, reject) => {
            import(widgetInstance.w).then(widget => {
                if (widget == 3) return; /* 3 == load error in dojo */
                var w: IWidget = null;

                /* ES6 export */
                if (widget["default"] != null) {
                    w = <IWidget>new widget["default"](); /* Create instance */
                } else {
                    w = <IWidget>new widget();
                }
                this._widget = w;


                var isInitializedPromise = <Promise<any>>w.initialize({
                    currentUser: this._global.cu,
                    iid: widgetInstance.iid,
                    did: widgetInstance.did,
                    root: this.$container[0],
                    lang: this._global.l,
                    params: params,
                    rootUrl: widgetInstance.ru,
                    page: this._global.p,
                    widgetTopic: this.widgetTopicname,
                    dashboards: this.dashboards,
                    container: this
                });

                /* Check if widget returns a promise */
                if (isInitializedPromise != null && isInitializedPromise.then != null) {
                    /* Widget returned a promise => show loading */
                    var originalPositionValue = this.$container.css('position');
                    this.$container.css('position', 'relative');
                    this.$container.css('min-height', '30px');
                    kendo.ui.progress(this.$container, true);

                    isInitializedPromise.then((data: any) => {
                        if (data != null) {
                            if (data.title != null) {
                                this.setTitle(data.title);
                            }
                        }

                        /* disable progress bar */
                        kendo.ui.progress(this.$container, false);
                        this.$container.css('position', originalPositionValue);
                        resolve(w);
                    }).catch((error: any) => {
                        /* Widget not initialized correctly */
                        kendo.ui.progress(this.$container, false);
                        this.$container.css('position', originalPositionValue);
                        reject(error);
                    });

                } else {
                    /* No lazy initalize function */
                    resolve(w);
                }
            }).catch(ex => {
                console.error(ex);
                reject(ex);
            });
        });
    }

    private initButtons() {
        if (this.$btnArea.length != 0) {

            /* Eerst de fixed actions op container zetten => volgorde van icoontjes*/
            $.each(this._fixedActions, (key: string, value: any) => {
                var action = this._instance.a[key];
                if (action != null) {
                    if (action.text == null || action.text == "") { action.text = key; } else { value.text = action.text; /*update text value of fixedaction*/ }
                    value.button = this.addActionButton({ title: value.text, className: value.className, onclick: value.onclick });

                    /* todo -- kan dit niet generiek?? */
                    if (key == "help") {
                        value.button.data("url", action.helpId);
                    } else if (key == "print") {
                        value.button.data("url", action.action);
                    }
                }
            });

            /* Vervolgens alle custom actions op container zetten */
            $.each(this._instance.a, (key: string, value: any) => {
                if (!(key in this._fixedActions)) {
                    if (value.text == null || value.text == "") { value.text = key; }
                    if (value.icon == null || value.icon == "") { value.icon = "glyphicon glyphicon-cog"; }
                    if (value.actionId != null) { //TODO: action en clientid mergen?
                        this.addActionButton({ title: value.text, className: value.icon, onclick: () => { this.showWidgetInPopup(value.text, value.actionId, false); } });
                    } else if (value.action != null) { //TODO: DEPRECATED
                        this.addActionButton({ title: value.text, className: value.icon, onclick: () => { this.showUrlInPopup(value.text, value.action); } });
                    } else {
                        this.addActionButton({ title: value.text, className: value.icon, onclick: () => { this.sendAction(key); } });
                    }
                }
            });
        }
    }
    private addActionButton(btn: { title: string, className: string, onclick: () => void }): JQuery {
        /* Create button and set text */
        var $b = $('<button type="button" class="btn btn-default">');
        $b.attr("title", btn.title);
        $b.text(" " + btn.title);

        /* Create icon and append icon */
        var $icon = $('<span>');
        $icon.addClass(btn.className);
        $icon.prependTo($b);

        /* Add click handler */
        $b.on('click', btn.onclick);

        this.$btnArea.prepend($b);
        return $b;
    }

    private toggleButton(options: { button: any, iconMainClass: any, state1: any, state2: any }, expected: number) {
        var _btn = $(options.button);
        var _icon = _btn.find("." + options.iconMainClass);

        if (_icon.hasClass(options.state1.iconClass)) {
            if (expected === 1) { return 1; }
            _icon.removeClass(options.state1.iconClass).addClass(options.state2.iconClass);
            _btn.attr('title', options.state2.title);
            return 2;
        } else {
            if (expected === 2) { return 2; }
            _icon.removeClass(options.state2.iconClass).addClass(options.state1.iconClass);
            _btn.attr('title', options.state1.title);
            return 1;
        }
    };

    private saveState(state: string) {
        import('CMS/conf').then(c => {
            if (this._global.cu.permissions.indexOf("Widget.SaveConfiguration") < 0) {
                return false;
            }
            c.save({
                success: (data: any) => { },
                error: (msg: any) => {
                    import('CMS/Popup').then(Popup => {
                        Popup.showError(msg);
                    });
                },
                data: {
                    uid: this._global.cu.id,
                    iid: this._instance.iid,
                    scope: "moduleInstance",
                    userSetting: true,
                    params: { "state": state }
                }
            });
        });
    }

    private getDashboardNameById(id: string) {
        for (var i = 0; i < this.dashboards.length; i++) {
            if (this.dashboards[i].id == id) {
                return this.dashboards[i].name;
            }
        }
        return null;
    }

    private unsetGUIMaximized() {
        if (this._fp == null) { return; }
        this._fp.fullPage("reset");
        if (this.rememberedHeight != null) {
            this.$container.height(this.rememberedHeight);
        }
        this.rememberedHeight = null;
        this._fp = null;
        this._sortable.sortable('enable');
    }
    private setGUIMaximized() {
        if (this._fp != null) { return; }
        import('CMS/core/fullPage').then((fs: any) => {
            this.rememberedHeight = this.$container.height();

            var _restore = $('<div>');
            this.$wrapper.before(_restore);
            //TODO:  hardcoded container gelinkt aan de layout..
            var _contentWrapper = $(".contentWrapper");
            this._fp = (<any>this.$wrapper).fullPage({ restore: _restore, offset: { top: _contentWrapper.offset().top } });

            var _fpWrapper = this._fp.closest('.fullPageWrapper');
            var _fullHeight = _fpWrapper.height();
            var _diff = this.$wrapper.outerHeight() - this.$container.height();
            this.$container.height(_fullHeight - _diff);
            this._sortable.sortable('disable');
        });
    }

    private setGUIState() {
        var _btnMinimizeSettings = {
            button: this._fixedActions.minimize.button, iconMainClass: 'myIcon',
            state1: { iconClass: 'vl-icon vl-minimize', title: this._fixedActions.minimize.text },
            state2: { iconClass: 'k-icon k-i-arrowhead-s', title: "restore" }
        };
        var _btnMaximizeSettings = {
            button: this._fixedActions.maximize.button, iconMainClass: 'vl-icon',
            state1: { iconClass: 'vl-maximize', title: this._fixedActions.maximize.text },
            state2: { iconClass: 'vl-restore', title: "restore" }
        };

        if (this._state == "normal") {
            this.unsetGUIMaximized();
            this.toggleButton(_btnMinimizeSettings, 1);
            this.toggleButton(_btnMaximizeSettings, 1);
            this.$container.show();
            this.$btnArea.find('.vl-minimize').parent().show();
            this.$btnArea.find('.vl-maximize').parent().show();
        } else if (this._state == "minimized") {
            this.toggleButton(_btnMinimizeSettings, 2);
            this.$container.hide();
            this.$btnArea.find('.vl-maximize').parent().hide();
        } else if (this._state == "maximized") {
            this.toggleButton(_btnMaximizeSettings, 2);
            this.setGUIMaximized();
            this.$btnArea.find('.vl-minimize').parent().hide();
        }
    }

    public getState() {
        var _pos = this.$moduleContent.offset();
        if (_pos == null) { _pos = { top: 0, left: 0 }; }
        return {
            visible: !this.$container.is(':hidden'),
            width: this.$container.width(),
            height: this.$container.height(),
            state: this._state,
            top: _pos.top,
            left: _pos.left
        };
    }

    private minimize(e: any) {
        if (this._state == "normal") {
            this._state = "minimized";
        } else if (this._state == "minimized") {
            this._state = "normal";
        } else if (this._state == "maximized") {
            throw 'Illegal switch from maximized to minimized';
        }

        this.setGUIState();

        //bizarre check.. maar is correct...
        if (e.tellWidget == null) {
            this.sendAction("minimize");
        }
        this.saveState(this._state);
    }

    private maximize(e: any) {
        if (this._state == "normal") {
            this._state = "maximized";
        } else if (this._state == "maximized") {
            this._state = "normal";
        } else if (this._state == "minimized") {
            throw 'Illegal switch from minimized to maximized';
        }

        this.setGUIState();

        //bizarre check.. maar is correct...
        if (e.tellWidget == null) {
            this.sendAction("maximize");
        }
    };
    private print(e: any) {
        var url = $(e.target).parent().data("url");
        window.open(url);
    };

    private download(e: any) {
        import('CMS/Popup').then(Popup => {
            Popup.showWarning('Download is not available yet');
        });
    };

    private delete(e: any) {
        if (window.confirm("Bent u zeker dat u deze widget wilt verwijderen?")) {
            import('CMS/conf').then((c: any) => {
                c.deleteWidget({
                    data: { iid: this._instance.iid.substr(1) },
                    success: () => {
                        //$wrapper.hide();
                        this.$wrapper.remove();
                    }, error: (msg: string) => {
                        console.error("deleting failed " + msg);
                    }
                });
            });
        }
    };

    private help(e: any) {
        import('CMS/Popup').then(Popup => {
            var url = $(e.target).parent().data("url");
            Popup.show({ title: 'Help', pageID: url });
        });
    };

    private addToDashboard(e: any) {
        if (this.$addToDashboardDiv == null && this.dashboards != null && this.dashboards.length > 0) {
            this.$addToDashboardDiv = $('<div />');
            this.$dashboardSelect = $('<select />');
            this.$dashboardSelect.append('<option value="0" selected="true" disabled="true" style="display:none">Kies een dashboard</option>'); //TODO: translation
            for (var i = 0; i < this.dashboards.length; i++) {
                this.$dashboardSelect.append('<option value="' + this.dashboards[i].id + '">' + this.dashboards[i].name + '</option>');
            }
            this.$dashboardSelect.appendTo(this.$addToDashboardDiv);
            this.$addToDashboardDiv.prependTo(this.$container);

            this.$dashboardSelect.change((e: any) => {
                Promise.all(['CMS/dashboard', 'CMS/notification']).then((imports) => {
                    var dashboard: any = imports[0];
                    var notification: any = imports[1];

                    var dashboardId = this.$dashboardSelect.val();
                    dashboard.copyWidgetToDashboard({
                        page: this._global.p,
                        data: { iid: this._instance.iid.substr(1), dashboard: dashboardId },
                        success: () => {
                            notification.show({ config: { text: 'Succesvol toegevoegd aan ' + this.getDashboardNameById(dashboardId), type: 'success', timeout: 2000 } }); //TODO: translation
                            this.$addToDashboardDiv.hide();
                            this.$moduleContent.css("minHeight", "0px");
                        }, error: (msg: string) => {
                            notification.show({ config: { text: 'Toevoegen aan ' + this.getDashboardNameById(dashboardId) + ' mislukt', type: 'error', timeout: 2000 } }); //TODO: translation
                            this.$addToDashboardDiv.hide();
                            this.$moduleContent.css("minHeight", "0px");
                        }
                    });
                });
            });

            this.$addToDashboardDiv.addClass('addToDashboard');
            this.$moduleContent.css("minHeight", this.$addToDashboardDiv.outerHeight() + "px");
            this.$addToDashboardDiv.show();

        } else {
            this.$dashboardSelect.prop('selectedIndex', 0);
            this.$addToDashboardDiv.toggle();
            if (this.$addToDashboardDiv.is(":visible")) {
                this.$moduleContent.css("minHeight", "30px");
            } else if (this.$addToDashboardDiv.is(":hidden")) {
                this.$moduleContent.css("minHeight", "0px");
            }
        }
    };



    private showUrlInPopup(title: string, url: string) {
        import('CMS/Popup').then(Popup => {
            Popup.show({ title: title, url: url });
        });
    };

    private showWidgetInPopup(title: string, actionId: any, maximizable: any) {
        import('CMS/Popup').then(Popup => {
            //TODO: => dit moet enkel options en global object binnenkrijgen..
            Popup.show({ maximizable: maximizable, title: title, actionID: actionId, minWidth: 500, minHeight: 300, global: this._global, instance: this._instance });
        });
    };

    private showPageInPopup(title: string, page: any) {
        import('CMS/Popup').then(Popup => {
            Popup.show({ title: title, page: page });
        });
    };


    private getContainer(): JQuery {
        return this.$container;
    }


    private showAdvancedOptions(webModuleInstanceId: string) {
        import('CMS/Popup').then(Popup => {
            Popup.show({
                title: 'Settings',
                params: {
                    settings: webModuleInstanceId
                },
                page: 'CMS/ModuleSettings'
            });
        });
    }
}


// public getContainer: deprecated
// public getConfiguredHeight: deprecated -> vervangen door property configuredHeight
